import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { UploadDialogComponent } from '../upload-dialog/upload-dialog.component';

@Component({
    selector: 'app-upload-dialog-button',
    templateUrl: './upload-dialog-button.component.html',
    styleUrls: ['./upload-dialog-button.component.scss'],
    standalone: false
})
export class UploadDialogButtonComponent {
  @ViewChild('uploadDialog')
  uploadDialog!: UploadDialogComponent;

  @Input() heading: string = 'Upload List';

  @Input() buttonText?: string = 'Upload';

  @Input() showNote: boolean = false;

  @Input()
  footerNote: string =
    'Mandatory columns should be present (email and designations)';

  @Output() submitClick = new EventEmitter();

  @Output() sampleDownload = new EventEmitter();

  switchValue: boolean = false;

  fnOnToggleSwitch() {
    if (this.switchValue) {
      this.uploadDialog.openModal();
    } else {
      this.uploadDialog.fnCloseUploadModal();
    }
  }

  closeModal() {
    this.switchValue = false;
    this.uploadDialog.fnCloseUploadModal();
  }
}
